import * as React from "react"
import {useEffect} from "react"
import {object, string} from "yup";
import {TextFieldSeeker} from "@ui-seeker/core";
import {useValidatorSeeker} from "@ui-seeker/app";

import {useMatchersSkusForm} from "../../@hooks";
import {matcherSKUDrawerError} from "../../@signals";


export default function MatchersSKUsDrawerSize() {
	const { localValue, handleChange } = useMatchersSkusForm('size')
	const { errors } = useValidatorSeeker({
		size: localValue
	}, object({
		size: string().required('Size is mandatory')
	}))

	useEffect(() => {
		matcherSKUDrawerError.value = {
			...matcherSKUDrawerError.value,
			size: errors?.size
		}
	}, [errors?.size]);

    return <TextFieldSeeker
		fullWidth
		label="Size"
		placeholder="Please enter the size"
		value={localValue || ''}
		onChange={e => handleChange(e.target.value)}
		error={errors?.size}
	/>
}
